import { AnalyticEventName, track } from 'src/core/utils/analytics';

export const useTriggerSurvey = () => {
  return () => {
    setTimeout(() => {
      track(AnalyticEventName.COST_CENTERS_SURVEY_TRIGGERED);
    }, 3000);
  };
};
